export const actionTypes = {
  POST_AUTH: 'POST_AUTH',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAIL: 'LOGIN_FAIL',
  LOGOUT: 'LOGOUT'
};

export const getLogout = (uid: string) => ({
  type: actionTypes.LOGOUT,
  uid
});
